import script from "./AppletSetting.vue?vue&type=script&setup=true&lang=js"
export * from "./AppletSetting.vue?vue&type=script&setup=true&lang=js"

import "./AppletSetting.vue?vue&type=style&index=0&id=0e1010f3&scoped=true&lang=stylus"

import exportComponent from "C:\\D\\workspace\\idea\\tkt-web\\camee-sport-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e1010f3"]])

export default __exports__